import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { ClientInterface, IdInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class CheckApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    checkClient(client: ClientInterface, captcha: string) {
        return this.transactionRequest.wrap(this.apiClient.checkClient(client, captcha));
    }

    checkEmail(email: string, clientCode?: IdInterface): Observable<Transaction<boolean>> {
        return this.transactionRequest.wrap(this.apiClient.checkEmail(email, clientCode));
    }

    checkPhone(phone: string, clientCode?: IdInterface): Observable<Transaction<boolean>> {
        return this.transactionRequest.wrap(this.apiClient.checkPhone(phone, clientCode));
    }
}
